export const ECdnDocType = {
  "0": "UNKNOWN",
  "1": "TEMP",
  "2": "GSA_LOGO",
  "3": "AGENCY_LOGO",
  "4": "AIRLINE_LOGO",
  "5": "RENTACAR_VEHICLE_TYPE",
  "6": "TRANSFER_VEHICLE_TYPE",
  "7": "ANNOUNCEMENT_POSTER",
  "8": "USER_LOGO",
  "9": "HOTEL_ADD_ON",
  "1000": "EMAIL_ATTACHMENT",
  "1001": "AGENCY_CONTRACT",
  "1002": "AGENCY_TRADE_REGISTERY",
  "1003": "AGENCY_SEPA_REGISTERY",
  "1004": "HOTEL_CACHE_DATA",
  "1005": "API_IO_LOG",
  "1006": "APP_PROCESS_LOG",
  "-1": "ALL"
};

export const ECdnDocGroupType = {
  "0": "UNKNOWN",
  "1": "AGENCY",
  "-1": "ALL"
};

export const ECdnFileType = {
  "0": "UNKNOWN",
  "1": "HTML",
  "2": "PDF",
  "3": "JPG",
  "4": "PNG",
  "5": "XML",
  "6": "SVG",
  "7": "TXT",
  "8": "DOC",
  "9": "XLS",
  "10": "JSON",
  "11": "DOCX",
  "12": "XLSX",
  "13": "GZIP",
  "-1": "ALL"
};